import { createAppRequest } from "@/services/request";
import type {
  CalendarEventItem,
  CalendarQueryParams,
  CreateCalendarEventDto,
  UpdateCalendarEventDto,
} from "./types/calendar";
import type { ApiRequestOptions } from "./types/common";

const request = createAppRequest();
const BASE_PATH = "/bff/zy-crm/calendar/events";

export async function queryCalendarEvents(
  params: CalendarQueryParams,
  options?: ApiRequestOptions
) {
  return request<CalendarEventItem[]>(BASE_PATH, {
    method: "GET",
    params: {
      ...params,
      eventTypes: params.eventTypes?.join(","),
    },
    ...(options || {}),
  });
}

export async function queryCalendarEventsByBiz(
  bizType: string,
  bizUuid: string,
  options?: ApiRequestOptions
) {
  return request<CalendarEventItem[]>(`${BASE_PATH}/by-biz`, {
    method: "GET",
    params: {
      bizType,
      bizUuid,
    },
    ...(options || {}),
  });
}

export async function createCalendarEvent(
  payload: CreateCalendarEventDto,
  options?: ApiRequestOptions
) {
  return request<CalendarEventItem>(BASE_PATH, {
    method: "POST",
    data: payload,
    ...(options || {}),
  });
}

export async function updateCalendarEvent(
  uuid: string,
  payload: UpdateCalendarEventDto,
  options?: ApiRequestOptions
) {
  return request<CalendarEventItem>(`${BASE_PATH}/${uuid}`, {
    method: "PATCH",
    data: payload,
    ...(options || {}),
  });
}

export async function deleteCalendarEvent(
  uuid: string,
  options?: ApiRequestOptions
) {
  return request<{ uuid: string; deleted: boolean }>(`${BASE_PATH}/${uuid}`, {
    method: "DELETE",
    ...(options || {}),
  });
}

export interface ExternalCalendarResult {
  events: CalendarEventItem[];
  errors: Array<{ source: string; message: string }>;
}
export const queryExternalCalendarEvents = (params: CalendarQueryParams) => request<ExternalCalendarResult>('/bff/zy-crm/calendar/external-events', { method: 'GET', params: { ...params, eventTypes: params.eventTypes?.join(',') }, skipErrorHandler: true });
